import * as React from "react";
import { fetchCanUseAssistant } from "../api/assistant";

export type AssistantAccessState =
  | { status: "idle" }
  | { status: "loading" }
  | { status: "allowed" }
  | { status: "denied" }
  | { status: "error"; message: string };

/**
 * Resolve Ask Cenna entry permission (``assistant:use``) when the chat surface is active
 * or when the shell needs to know whether to enable the Ask Cenna tab.
 */
export function useAssistantAccess(enabled: boolean): AssistantAccessState {
  const [state, setState] = React.useState<AssistantAccessState>({ status: "idle" });

  React.useEffect(() => {
    if (!enabled) {
      setState({ status: "idle" });
      return undefined;
    }

    let cancelled = false;
    setState({ status: "loading" });

    void (async () => {
      try {
        const allowed = await fetchCanUseAssistant();
        if (cancelled) return;
        setState(allowed ? { status: "allowed" } : { status: "denied" });
      } catch (e) {
        if (cancelled) return;
        setState({
          status: "error",
          message: e instanceof Error ? e.message : String(e),
        });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
